export default __webpack_public_path__ + "static/ai-marketing-4--mobile-7d7bc3e7f20d8ed3b0babd634b0b5a75.webp";